export default __webpack_public_path__ + "assets/4172ff57b5b48c79c2fcb0ef3eac9ec3.png";